import { IMAGES } from "../data/images";

export const getDefaultUserAvatar = (avatar) => {
  if (typeof avatar == "string" && avatar.length > 0) return avatar;

  return IMAGES.DEFAULT_AVATAR;
};
